import Heading from "../ui/Heading.jsx";

function Health() {
    return (
        <div className="pt-10 mx-auto w-full max-w-2xl px-4">
            <div className="bg-white rounded-lg space-y-6">
                <Heading className="text-center font-bold mb-4">
                    Health and Safety
                </Heading>
                <p className="text-gray-700 text-center">
                    Staying safe while having the time of your life.
                </p>

                <p className="text-gray-700">
                    We believe queer parties should be wild, joyful, and most of all, safe.
                    Whether you&apos;re a first-timer or a seasoned party animal, here are some tips
                    to help you and your friends stay fabulous and protected while you&apos;re out and about.
                </p>

                <section className="mt-6">
                    <h2 className="text-xl font-semibold mb-2">Important Disclaimer</h2>
                    <p className="text-slate-700">
                        The information on this page is for general informational purposes only
                        and is not medical advice. Always seek professional guidance if you have
                        concerns about your health, substance use, or wellbeing. UnicorNation is
                        not responsible for any decisions you make or outcomes that arise from
                        using this information.
                    </p>
                </section>


                <section>
                    <h2 className="text-xl font-semibold mb-2">While You’re Partying</h2>
                    <ul className="list-inside space-y-1 text-gray-700">
                        <li>
                            <strong>Stay with your crew:</strong> Stick with friends or arrange check-ins if you split up. Watch out for each other.
                        </li>
                        <li>
                            <strong>Consent is everything:</strong> Always ask. Whether it’s dancing, touching, or more intimate moments, a clear yes is sexy. Anything less is a no.
                        </li>
                        <li>
                            <strong>Know your limits:</strong> Pace yourself and never accept drinks from strangers.
                        </li>
                        <li>
                            <strong>Hydrate and rest:</strong> Especially if you&apos;re dancing or feeling hot. Sip water regularly and take breaks if you feel overwhelmed.
                        </li>
                    </ul>
                </section>

                <section>
                    <h2 className="text-xl font-semibold mb-2">If Something Goes Wrong</h2>
                    <ul className="list-inside space-y-1 text-gray-700">
                        <li>
                            <strong>Emergency contacts:</strong> Save local emergency numbers in your phone. In Australia, dial <strong>000</strong> for police, ambulance, or fire.
                        </li>
                        <li>
                            <strong>Look after each other:</strong> If a friend is out of it, dizzy, or acting strange, don’t leave them alone. Get them help.
                        </li>
                        <li>
                            <strong>Report harassment or assault:</strong> If someone makes you uncomfortable, tell someone. You deserve to feel safe and respected, always.
                        </li>
                    </ul>
                </section>

                <section>
                    <h2 className="text-xl font-semibold mb-2">Finally: Respect the Vibe</h2>
                    <p className="text-gray-700">
                        Gay parties are sacred queer spaces. They&apos;re fun, sexy, freeing, but also communal and powerful. Respect the diversity of bodies, genders, and expressions you’ll encounter. Lift each other up, and leave no unicorn behind.
                    </p>
                </section>

                <section className="bg-brand-secondary-pink-100 p-4 rounded-md text-center">
                    <h3 className="text-lg font-bold text-pink-700 ">Be wild, be safe, be you.</h3>
                    <p className="text-gray-700 mb-2">Need help or want to talk?</p>
                    <ul className="space-y-1 text-gray-800">
                        <li>
                            <strong>QLife (Australia):</strong> 1800 184 527 or <a href="https://qlife.org.au" className="text-blue-600 underline">qlife.org.au</a>
                        </li>
                        <li>
                            <strong>Thorne Harbour Health:</strong> <a href="https://thorneharbour.org" className="text-blue-600 underline">thorneharbour.org</a>
                        </li>
                        <li>
                            <strong>ACON (NSW):</strong> <a href="https://acon.org.au" className="text-blue-600 underline">acon.org.au</a>
                        </li>
                    </ul>
                </section>
            </div>
        </div>
    );
}

export default Health;
